import CreatableSelect from "react-select/creatable"

interface EventTypeOption {
    value: string
    label: string
}

interface CreatableEventTypesSelectProps {
    values: string[]
    onChange: (values: string[]) => void
}

export const CreatableEventTypesSelect = ({
    values,
    onChange,
}: CreatableEventTypesSelectProps) => {
    const options = values.map((value) => ({ value, label: value }))

    return (
        <CreatableSelect<EventTypeOption, true>
            isMulti
            value={options}
            options={options}
            placeholder="Все типы событий"
            formatCreateLabel={(input) => `Добавить «${input}»`}
            noOptionsMessage={() => "Введите тип события"}
            className="flex h-[52px] w-full items-center rounded-full bg-white px-4 text-color-dark"
            classNamePrefix="react_select_custom"
            classNames={{
                control: () => "!min-h-0 w-full !border-0 !p-0 !shadow-none",
                valueContainer: () => "!p-0",
            }}
            onChange={(selected) => onChange(
                selected.map((option) => option.value.trim()).filter(Boolean)
            )}
        />
    )
}
